function makeExtendable(SuperClass) {
  SuperClass.extend = function(proto) {
    const SubClass = proto.hasOwnProperty("constructor")
      ? function SubClass() { proto.constructor.apply(this, arguments); }
      : function SubClass() { SuperClass.apply(this, arguments); };

    SubClass.prototype = Object.create(SuperClass.prototype);
    Object.defineProperties(SubClass.prototype, Object.getOwnPropertyDescriptors(proto));
    // assign(SubClass.prototype, proto); // old way before getOwnPropertyDescriptors polyfill for IE
    SubClass.prototype.constructor = SubClass;

    makeExtendable(SubClass);
    return SubClass;
  }
}

export default function ExtendableObject() {}
makeExtendable(ExtendableObject);
